import './style';

ko.bindingHandlers.stickyFooter = {
  init: function (
    element,
    valueAccessor,
    allBindings,
    viewModel,
    bindingContext
  ) {
    element.classList.add('sticky-footer');

    let observer = new IntersectionObserver(([entry]) => {
      const rect = entry.boundingClientRect;
      if (rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0) {
        return;
      }

      if (entry.intersectionRatio < 1 && entry.intersectionRatio !== 0) {
        element.classList.add('stucky');
      } else {
        element.classList.remove('stucky');
      }
    }, {
      threshold: [0.0, 1.0]
    });
    observer.observe(element);

    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      observer.disconnect();
      observer = null;
    });
  },
  update: function (
    element,
    valueAccessor,
    allBindings,
    viewModel,
    bindingContext
  ) {}
};
